import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';
import { invalidateOrder } from './invalidateOrder';

interface CancelScheduledOrderPlacementInput {
    orderId: string;
}

const cancelScheduledOrderPlacement = async (data: CancelScheduledOrderPlacementInput, sessionId: string | null) => {
    return axios.put(`${API_URL}/order/place/cancel`, data, {
        headers: {
            Authorization: sessionId
        }
    });
};

export const useCancelScheduledOrderPlacement = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CancelScheduledOrderPlacementInput) =>
            cancelScheduledOrderPlacement(data, sessionContext?.sessionId ?? null),
        onSuccess: (_data, variables) => {
            void invalidateOrder(queryClient, variables.orderId);
        },
        onError: (error) => {
            console.error('Failed to cancel scheduled order placement:', error);
        }
    });
};
